import { Interval } from "@digits-graphql/frontend/graphql-bearer"

export const DATE_RANGE_MAX_DAYS = 60

export type DateRangeOption = "range" | "single" | false

export type DateRangeIntervalOptions = {
  [Interval.Day]: DateRangeOption
  [Interval.Month]: DateRangeOption
  [Interval.Quarter]: DateRangeOption
  [Interval.Year]: DateRangeOption
}

export const DEFAULT_INTERVALS_OPTIONS: DateRangeIntervalOptions = {
  [Interval.Day]: false,
  [Interval.Month]: "single",
  [Interval.Quarter]: "single",
  [Interval.Year]: "single",
}

export const RANGE_INTERVALS_OPTIONS: DateRangeIntervalOptions = {
  [Interval.Day]: false,
  [Interval.Month]: "range",
  [Interval.Quarter]: "range",
  [Interval.Year]: "range",
}

export const DETAILS_INTERVALS_OPTIONS: DateRangeIntervalOptions = {
  [Interval.Day]: "range",
  [Interval.Month]: "range",
  [Interval.Quarter]: "range",
  [Interval.Year]: "range",
}
